// extracted by mini-css-extract-plugin
export var formContainer = "_k5-0";
export var message = "_k5-1";